module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "common-store-wrapper"
  }, [_c('div', {
    staticClass: "common-store-header-nav"
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("店铺")]), _c('span', [_vm._v("  >  ")]), _c('span', {
    staticStyle: {
      "color": "#B6B6B6"
    }
  }, [_vm._v(_vm._s(_vm.storeName))])]), _vm._v(" "), _c('div', {
    staticClass: "common-store-search"
  }, [_c('div', {
    staticClass: "common-store-search-type"
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "color": "#B6B6B6"
    }
  }, [_vm._v("店铺类型：")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.storeType == '2' ? 'search-type-store-active' : '',
    on: {
      "click": function($event) {
        return _vm.storeTypeHandle('2')
      }
    }
  }, [_vm._v("企业店铺")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.storeType == '4' ? 'search-type-store-active' : '',
    on: {
      "click": function($event) {
        return _vm.storeTypeHandle('4')
      }
    }
  }, [_vm._v("金牌店铺")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.storeType == '5' ? 'search-type-store-active' : '',
    on: {
      "click": function($event) {
        return _vm.storeTypeHandle('5')
      }
    }
  }, [_vm._v("银牌店铺")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.storeType == '1' ? 'search-type-store-active' : '',
    on: {
      "click": function($event) {
        return _vm.storeTypeHandle('1')
      }
    }
  }, [_vm._v("个体店铺")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.storeType == '' ? 'search-type-store-active' : '',
    on: {
      "click": function($event) {
        return _vm.storeTypeHandle('')
      }
    }
  }, [_vm._v("不限")])]), _vm._v(" "), _c('div', {
    staticClass: "common-store-search-type"
  }, [_c('div', {
    staticStyle: {
      "width": "100px",
      "color": "#B6B6B6"
    }
  }, [_vm._v("好评率：")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.praiseRateType == 1 ? 'search-type-hp-active' : '',
    on: {
      "click": function($event) {
        return _vm.praiseRateTypeHandle(1)
      }
    }
  }, [_vm._v("100%")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.praiseRateType == 2 ? 'search-type-hp-active' : '',
    on: {
      "click": function($event) {
        return _vm.praiseRateTypeHandle(2)
      }
    }
  }, [_vm._v("99%以上")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.praiseRateType == 3 ? 'search-type-hp-active' : '',
    on: {
      "click": function($event) {
        return _vm.praiseRateTypeHandle(3)
      }
    }
  }, [_vm._v("98%以上")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.praiseRateType == 4 ? 'search-type-hp-active' : '',
    on: {
      "click": function($event) {
        return _vm.praiseRateTypeHandle(4)
      }
    }
  }, [_vm._v("97%以上")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.praiseRateType == 5 ? 'search-type-hp-active' : '',
    on: {
      "click": function($event) {
        return _vm.praiseRateTypeHandle(5)
      }
    }
  }, [_vm._v("96%以上")]), _vm._v(" "), _c('div', {
    staticClass: "search-type-item",
    class: _vm.praiseRateType == 6 ? 'search-type-hp-active' : '',
    on: {
      "click": function($event) {
        return _vm.praiseRateTypeHandle(6)
      }
    }
  }, [_vm._v("不限")])])]), _vm._v(" "), _c('div', {
    staticClass: "common-store-sort"
  }, [_c('div', {
    staticClass: "common-store-sort-left"
  }, [_c('div', {
    staticClass: "common-store-sort-left-item",
    class: _vm.sortType == 0 ? 'store-sort-active' : '',
    on: {
      "click": function($event) {
        return _vm.sortTypeHandle(0)
      }
    }
  }, [_vm._v("综合排序")]), _vm._v(" "), _c('div', {
    staticClass: "common-store-sort-left-item",
    class: _vm.sortType == 1 ? 'store-sort-active' : '',
    on: {
      "click": function($event) {
        return _vm.sortTypeHandle(1)
      }
    }
  }, [_vm._v("销量")]), _vm._v(" "), _c('div', {
    staticClass: "common-store-sort-left-item",
    class: _vm.sortType == 2 ? 'store-sort-active' : '',
    on: {
      "click": function($event) {
        return _vm.sortTypeHandle(2)
      }
    }
  }, [_vm._v("信用")])]), _vm._v(" "), _c('div', {
    staticClass: "hasCollect-sty"
  }, [_c('el-checkbox', {
    attrs: {
      "label": "收藏"
    },
    on: {
      "change": _vm.hasCollectChange
    },
    model: {
      value: (_vm.hasCollect),
      callback: function($$v) {
        _vm.hasCollect = $$v
      },
      expression: "hasCollect"
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.storeList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "common-store-box"
    }, [_c('div', {
      staticClass: "common-store-box-title"
    }, [_c('div', {
      staticClass: "common-store-box-title-left",
      on: {
        "click": function($event) {
          return _vm.gotoShop(item)
        }
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "82px",
        "height": "82px",
        "border-radius": "8px"
      },
      attrs: {
        "fit": "cover",
        "src": item.storeLogo || require('./../../../static/tyjf.png')
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "30px"
      }
    }, [_c('div', {
      staticStyle: {
        "color": "#313131",
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(item.storeName))]), _vm._v(" "), _c('div', {
      staticStyle: {
        "color": "#9D9D9D"
      }
    }, [_vm._v(_vm._s(item.praiseRate * 100 + '%'))])])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.hasCollect),
        expression: "!item.hasCollect"
      }],
      staticClass: "common-store-box-title-right",
      on: {
        "click": function($event) {
          return _vm.addCollection(item, index)
        }
      }
    }, [_vm._v("\n          关注\n        ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.hasCollect),
        expression: "item.hasCollect"
      }],
      staticClass: "common-store-box-title-right",
      staticStyle: {
        "background": "#B6B6B6"
      },
      on: {
        "click": function($event) {
          return _vm.favoriteDelete(item, index)
        }
      }
    }, [_vm._v("\n          已关注\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "common-store-box-list"
    }, [(item.storeGoodsVoList.length > 0) ? _c('div', {
      staticStyle: {
        "width": "100%",
        "height": "100%",
        "display": "flex"
      }
    }, _vm._l((item.storeGoodsVoList), function(v, k) {
      return _c('div', {
        key: k,
        staticClass: "common-store-box-list-item",
        staticStyle: {
          "margin-right": "24px"
        },
        on: {
          "click": function($event) {
            return _vm.gotoPage(v)
          }
        }
      }, [_c('el-image', {
        staticStyle: {
          "height": "256px",
          "border-radius": "10px 10px 0 0"
        },
        attrs: {
          "fit": "cover",
          "src": v.thumbnail
        }
      }), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#393939",
          "text-align": "center"
        }
      }, [_vm._v("\n              " + _vm._s(v.name) + "\n            ")]), _vm._v(" "), _c('div', {
        staticStyle: {
          "color": "#EE1C25",
          "font-size": "20px",
          "text-align": "center"
        }
      }, [_vm._v("\n              ￥" + _vm._s(v.price) + "\n            ")])], 1)
    }), 0) : _c('div', {
      staticStyle: {
        "color": "rgb(157, 157, 157)"
      }
    }, [_vm._v("\n          暂无商品\n        ")])])])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a768b25e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common-store/index.vue
// module id = 1658
// module chunks = 1